export const CheckResource = {
  "CheckSuccess": "语法校验通过!",
  "ConfirmWhenError": "可能存在的语法问题如下, 是否仍保存?",
  "EsprimaSplit": "】-->【",
  "ErrorText": "在第 {0} 行，第 {1} 列出现错误, 原因是【{2}】。请检查红色下划线以及附近语法是否正常!",
  "ErrorDetail": "存在 {0} 个异常，详细信息如下：",
  "Error": "异常",
  "ContextNotSet": "在第 {0} 行, 上下文变量 --> 未设置!",
  "SessionNotSet": "在第 {0} 行, 会话变量 --> 未设置!",
  "ContextNotExist": "在第 {0} 行, 上下文变量【{1}】 --> 不存在!",
  "SessionNotExist": "在第 {0} 行, 会话变量【{1}】 --> 不存在!",
  "ParamIllegal": "在第 {0} 行, 函数【{1}】的参数不合法, 请检查!",
  "ParamArrayIllegal": "在第 {0} 行, 函数【{1}】的数组类型参数不合法, 请检查!",
  "ParamNumberWithZero": "在第 {0} 行, 函数【{1}】的参数数量不匹配, 需要 0 个或 {2} 个, 实际 {3} 个，请检查!",
  "ParamNumber": "在第 {0} 行, 函数【{1}】的参数数量不匹配, 需要 {2} 个, 实际 {3} 个, 请检查!",
  "SimpleNoProperty": "在第 {0} 行, 普通属性【{1}】没有子属性!",
  "ChildNoProperty": "在第 {0} 行, 子表【{1}】没有属性【{2}】!",
  "PropertyNoProperty": "在第 {0} 行, 字段【{1}】没有属性【{2}】!",
  "AddTwoManyParameters": "在第 {0} 行, 函数【{1}】的参数数量过多, 请检查!",
  "Token": "意外的记号",
  "ILLEGAL": "非法的标识符",
  "EndOfInpur": "意外的结束标识"
}